import React from 'react';

const InputRowItem = ({ left, right }: { left: React.ReactNode; right: React.ReactNode }) => {
  return (
    <div style={{ marginBottom: 12, display: 'flex', width: '100%' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '50%',
          alignItems: 'center',
        }}>
        <div style={{ paddingRight: 6, width: '100%' }}>{left}</div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          width: '50%',
          alignItems: 'center',
        }}>
        <b style={{ paddingLeft: 6 }}>{right}</b>
      </div>
    </div>
  );
};

export default InputRowItem;
